import { useSelector } from 'react-redux';
import { selectCurrentUser } from '@shared/store/auth.duck';
import { IsBetaTester } from '@shared/hooks/IsBetaTester';
import { isPremiumTierUser } from '@shared/utils/AccessControl';

/**
 * Three gates stack, and they answer different questions:
 *   beta    - can this company see the feature at all (temporary, drops when lockers ship)
 *   premium - is the company entitled to it (mirrors AccountTypeControlService.canUseLockers)
 *   toggle  - has a company admin switched it on
 *
 * Used by the sub-header item, the page guard and the panels so they cannot disagree.
 */
export function useLockersEnabled(): boolean {
  const user = useSelector(selectCurrentUser);
  const isBetaTester = IsBetaTester();
  return isBetaTester && isPremiumTierUser(user) && !!user?.companyEntity?.lockersEnabled;
}
